import LoginBackground from "../components/login/LoginBackground";

function Login() {
    return (
        <LoginBackground />
    );
}

export default Login;